var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{attrs:{"type":"flex","justify":"center","align":"center"}},_vm._l((_vm.btnList),function(item){return _c('el-button',{key:item.test,attrs:{"size":"small"},on:{"click":function($event){return item.trigger(_vm.scope.row)}}},[_vm._v(_vm._s(item.test))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }